import GatewayBase from './gateway-base';

export default class DeveloperRestService extends GatewayBase {
  createApp = (data: Record<string, unknown>) => {
    return this.client.post('/v1/developer/apps', data);
  };

  listApps = () => {
    return this.client.get('/v1/developer/apps');
  };

  getApp = (id: string) => {
    return this.client.get(`/v1/developer/apps/${id}`);
  };

  updateApp = (id: string, data: Record<string, unknown>) => {
    return this.client.put(`/v1/developer/apps/${id}`, data);
  };

  deleteApp = (id: string) => {
    return this.client.delete(`/v1/developer/apps/${id}`);
  };

  submitForReview = (id: string) => {
    return this.client.post(`/v1/developer/apps/${id}/submit`);
  };

  publishApp = (id: string) => {
    return this.client.post(`/v1/developer/apps/${id}/publish`);
  };

  rotateSecret = (id: string) => {
    return this.client.post(`/v1/developer/apps/${id}/rotate-secret`);
  };

  listInstallations = (appId: string) => {
    return this.client.get(`/v1/developer/apps/${appId}/installations`);
  };

  // Backend expects `ScopeItemDto[]` ({ name, required? }), not a flat string array —
  // a previous string-only signature would have failed validation. The Required/Optional
  // toggle on the consent screen relies on this shape.
  updateScopes = (id: string, scopes: { name: string; required?: boolean }[]) => {
    return this.client.put(`/v1/developer/apps/${id}/scopes`, { scopes });
  };

  listScopes = () => {
    return this.client.get('/v1/oauth/internal/scopes');
  };

  // Per-app team access (owner-only): the account's apps to pick from, a member's current
  // manageable apps, and setting which apps a member may manage.
  listAccountApps = () => {
    return this.client.get('/v1/developer/collaborators/apps');
  };

  getManageableApps = (userId: string) => {
    return this.client.get(`/v1/developer/collaborators/${userId}`);
  };

  setManageableApps = (userId: string, applicationIds: string[]) => {
    return this.client.put(`/v1/developer/collaborators/${userId}`, { applicationIds });
  };
}
